export class TblBidDataDisplay {
  id?: number;
  Domicile: string;
  Position: string;
  Round: number;
  Month: number;
  Offline?: boolean;
  Year: number;
  lines?: string;
  trips?: string;
  state?: string;
  fileid?: string;
  size?: string;
  modified?: any;
  created?: any;
  EmpNum: any;
  ShowDelete?: boolean;
  IsFirstRoundPaperBidder?: boolean;
  BidPeriodStartDate?: string;
  BidPeriodEndDate?: string;
  vacationLines?: string;
  vacationEomLines?: string;
  eomLines?: string;
  isEBGUser?: boolean;
  milLines?: string;
  isHistoricalBid?: boolean;
  isStateModified?: boolean;
  isQATest?:boolean; 
}
